module.exports = function() {

	function onResize() {
		var galleries = document.querySelectorAll('.js-resizeable-gallery');
		var i = 0;
		var max = galleries.length;
		var rama;

		if(window.jQuery !== undefined) {
			for(;i < max; i ++) {
				rama = $(galleries[i]).data('fotorama');
				if(rama) {
					rama.resize({
						height: galleries[i].parentNode.clientHeight
					});
				}
			}
		}
	}

	window.addEventListener('resize', onResize);
	onResize();

};


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/gallery.js
 **/